import { lazy, Suspense, memo } from "react";
import HeroSection from "./HeroSection";
import PoweredBy from "./PoweredBy";

// Lazy load below-the-fold components for better initial load performance
const BenefitsSection = lazy(() => import("./BenefitsSection"));
const Features = lazy(() => import("./Features"));
const Reviews = lazy(() => import("./Reviews"));
const FAQs = lazy(() => import("./FAQs"));
// const WaitRoom = lazy(() => import("./WaitRoom"));

// Simple loading fallback component
const SectionLoader = () => (
  <div className="flex items-center justify-center py-16">
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-600"></div>
  </div>
);

function Index() {
  return (
    <div className="bg-white">
      <main className={"dark:bg-gray-800"}>
        {/* Above-the-fold: Load immediately */}
        <HeroSection />
        <PoweredBy />
        <Suspense fallback={<SectionLoader />}>
          <BenefitsSection />
        </Suspense>

        {/* Below-the-fold: Lazy loaded with code splitting */}
        <Suspense fallback={<SectionLoader />}>
          <Features />
        </Suspense>
        <Suspense fallback={<SectionLoader />}>
          <Reviews />
        </Suspense>
        <Suspense fallback={<SectionLoader />}>
          <FAQs />
        </Suspense>
        {/* <Suspense fallback={<SectionLoader />}>
          <WaitRoom />
        </Suspense> */}
      </main>
    </div>
  );
}

// Memoize to prevent unnecessary re-renders
export default memo(Index);
